import { LegalClientRepresentativeEntity } from 'api/types/entity';
import { isFinanceProject, isGlobalProject } from 'config';
import { parseFullName } from 'helpers';
import { isLegalRepresentativeCompany } from 'modules/client/common/helpers';

import { LegalRepresentativeMainInfoType } from '../types';

const getLegalRepresentativeMainInfoForGlobal = (
  client: LegalClientRepresentativeEntity
): LegalRepresentativeMainInfoType => ({
  citizenship: client.citizenships?.[0],
  email: client.email,
  phone: client.phone,
  country: client.residentialAddress?.country,
  documentNumber: client.roleInCompany?.authorityConfirmationDocument.number,
  documentExpirationDate:
    client.roleInCompany?.authorityConfirmationDocument.dateOfExpiration,
});

const getLegalRepresentativeMainInfoForFinance = (
  client: LegalClientRepresentativeEntity
): LegalRepresentativeMainInfoType | undefined => {
  const isCompany = isLegalRepresentativeCompany(client);

  if (isCompany)
    return {
      representativeFullName: parseFullName(client),
      email: client.email,
      phone: client.phone,
      country: client.registrationAddress?.country,
      documentExpirationDate:
        client.roleInCompany?.authorityConfirmationDocument.dateOfExpiration,
    };

  return {
    email: client.email,
    phone: client.phone,
    country: client.registrationAddress?.country,
    documentNumber: client.roleInCompany?.authorityConfirmationDocument.number,
    documentExpirationDate:
      client.roleInCompany?.authorityConfirmationDocument.dateOfExpiration,
  };
};

export const getLegalRepresentativeMainInfo = (
  client: LegalClientRepresentativeEntity
): LegalRepresentativeMainInfoType | undefined => {
  if (isGlobalProject()) return getLegalRepresentativeMainInfoForGlobal(client);

  if (isFinanceProject())
    return getLegalRepresentativeMainInfoForFinance(client);

  return undefined;
};
